import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import logo from "../../../../assets/images/Group6967.png";
import { DesktopMainMenu, MaterialUISwitch, MenuLink } from "../styles";
import { toggleTheme } from '../../../../Redux/switchTheme'
import { useDispatch, useSelector } from "react-redux";
import styled from "@emotion/styled";



const SectionHeading = styled.h2`
  text-align: ${(props) => (props.align ? props.align : "left")};
  color: ${(props) => (props.color ? props.color : "#fff")};
  
  font-size: ${(props) => (props.fs ? props.fs : "30px")};
  font-family: "Matur";
  padding: ${(props) => (props.p ? props.p : "0")};
  line-height: 70px;
  margin: ${(props) => (props.m ? props.m : "0")};
  @media (max-width: 1399px) {
    font-size: ${(props) => (props.fs1399 ? props.fs1399 : "")};
  }
  `;

const DesktopMenu = (props) => {
  const currentTheme = useSelector( (state) => state.LDTheme.value )
  const dispatch = useDispatch();
 
  return (
    <DesktopMainMenu maxWidth="xl">
      <MenuLink href="/" p="0px" style={{display:'flex'}}>
        <img src={logo} width="80" height='72' alt="Logo" /> 
        <SectionHeading style={{color:'#fff'}} >PehPeh ペペ</SectionHeading>
      </MenuLink>
      <div style={{
    display: 'flex',alignItems: "center"}}>
        {props.menuList.map((value, i) => <MenuLink key={i} href={value.link} target={value.target} className={value.customClass}>{value.title}</MenuLink> )}
        {/* <FormControlLabel
          control={
            <MaterialUISwitch 
              sx={{ m: 1 }} 
              checked={currentTheme}
            />
          }
          onClick={() => dispatch(toggleTheme())}
        /> */}
      </div>
    </DesktopMainMenu>
  );
};

export default DesktopMenu;
